export default {
  // 2-1
  GET_APPLY_DATA(state, data) {
    state.factory_list = data.data.facList;
    state.workarea_list = data.data.workArea;
    state.reason_list = data.data.urgentReason;
    state.worktype_list = data.data.highRisk;
  },
  GET_MANAGER_LIST(state, data) {
    state.manager_list = data.data;
  },
  GET_SIGNER_LIST(state, data) {
    state.signer_list = data.data;
  },
  CHECK_CARDSTATUS_VALID(state, data) {
    state.cardValid = data.data.card_Status;
  },
  CHECK_LICENSE_VALID(state, data) {
    state.idValid = data.data.status;
  },
};
